<template>

</template>

<script>
export default {
  name: 'CouponsItems',
};
</script>

<style scoped>

</style>
